export enum IntegratedEmailsRoles {
  SENDER = 'roles.integratedEmailsSender',
}
